var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthmacedonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8249 23.862C15.7766 23.5643 17.5732 22.7957 19.0963 21.6768L12 12L13.8249 23.862Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.175 0.137939C8.22338 0.435689 6.42684 1.20425 4.90359 2.32311L12 12L10.175 0.137939Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90359 21.6768C6.42675 22.7957 8.22328 23.5643 10.1749 23.8621L12 12L4.90359 21.6768Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32313 4.90359C1.20422 6.42684 0.435752 8.22333 0.137955 10.175L12 12L2.32313 4.90359Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.137955 13.8249C0.435705 15.7766 1.20427 17.5732 2.32317 19.0963L12 12L0.137955 13.8249Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.862 10.175C23.5642 8.22336 22.7957 6.42683 21.6768 4.90363L12 12L23.862 10.175Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0963 2.32306C17.5731 1.20421 15.7766 0.435689 13.8249 0.137939L12 12L19.0963 2.32306Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6769 19.0964C22.7958 17.5732 23.5643 15.7766 23.8621 13.825L12 12L21.6769 19.0964Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 9.69483 14.3052 7.82611 12 7.82611C9.69483 7.82611 7.82611 9.69483 7.82611 12C7.82611 14.3052 9.69483 16.1739 12 16.1739Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.1304C13.7289 15.1304 15.1305 13.7289 15.1305 12C15.1305 10.2711 13.7289 8.86954 12 8.86954C10.2711 8.86954 8.86954 10.2711 8.86954 12C8.86954 13.7289 10.2711 15.1304 12 15.1304Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthmacedonia);
export default __webpack_public_path__ + "static/media/northmacedonia.9f0c207e4a7934a7b12302b11b1932ae.svg";
export { ForwardRef as ReactComponent };